<template>
  <div class="login">
    <div class="login-left">
      <div class="login-left-div animate__animated animate__bounceInLeft animate__fast">
        <h2>Weblog 博客登录</h2>
        <p>一款由 Spring Boot + Mybaits Plus + Vue 3.2 + Vite 4 开发的前后端分离博客。</p>
        <!-- 指定图片宽度为父级元素的 1/2 -->
        <img src="@/assets/img/developer.png" width="50%" />
      </div>
    </div>
    <div class="login-right">
      <login-panel></login-panel>
    </div>
    <IcpFooter class="login-icp" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import LoginPanel from './cpns/login-panel.vue'
import IcpFooter from '@/components/base/icp-footer.vue'

export default defineComponent({
  components: {
    LoginPanel,
    IcpFooter
  },
  setup() {
    return {}
  }
})
</script>

<style scoped lang="less">
.login {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .login-left {
    width: 50%;
    height: 100%;
    background-color: #0f172a;
    color: #fff;
    .login-left-div {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      h2 {
        font-weight: 700;
        margin-top: 20%;
        font-size: 28px;
      }
    }
  }

  .login-right {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    height: 100%;
    background-image: url('../../assets/img/login-bg.svg');
  }

  .login-icp {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 16px;
    z-index: 1;
  }
}
</style>
